import { useTranslation } from 'react-i18next';

import { BillingStatus } from '@lemoncloud/lemon-billings-api';

export const useGetBillingState = () => {
    const { t } = useTranslation();

    const getBillingState = (state: BillingStatus | undefined) => {
        if (!state) {
            return t('myPage.billing.state.exception');
        }

        switch (state) {
            case 'init':
                return t('myPage.billing.state.init');
            case 'paid':
                return t('myPage.billing.state.paid');
            case 'waiting':
                return t('myPage.billing.state.waiting');
            case 'toCancel':
                return t('myPage.billing.state.toCancel');
            case 'canceled':
                return t('myPage.billing.state.canceled');
            case 'failed':
                return t('myPage.billing.state.failed');
            default:
                return t('myPage.billing.state.exception');
        }
    };

    return getBillingState;
};
